<div class="list-group list-group-striped border-rad-all-12 card-shadow">
  <div class="list-group-item">
    <div class="row">
      <h5 class="col-lg-11">
        {{ 'tkey;admin.proxy_server_management.proxy_feature_settings.ad_write_down.title.zpm' | translate }}
      </h5>
      <div class="d-flex justify-content-end col-lg-1">
        <ziro-checkbox [fieldId]="'onPremAdWriteDownEnabled'"></ziro-checkbox>
      </div>
    </div>
    <p>{{ 'tkey;admin.proxy_server_management.proxy_feature_settings.ad_write_down.description.zpm' | translate }}</p>
  </div>
  <div class="list-group-item">
    <div class="row">
      <h5 class="col-lg-11">
        {{ 'tkey;admin.proxy_server_management.proxy_feature_settings.number_assignment_check.title.zpm' | translate }}
      </h5>
      <div class="d-flex justify-content-end col-lg-1">
        <ziro-checkbox [fieldId]="'cucmPhoneNumberAssignmentCheckEnabled'"></ziro-checkbox>
      </div>
    </div>
    <p
      [ngClass]="{ 'mb-0': !dialPlanSyncToggleEnabled }"
      [innerHTML]="
        'tkey;admin.proxy_server_management.proxy_feature_settings.number_assignment_check.description.zpm' | escapeHtml
      "
    ></p>
    <div [hidden]="!dialPlanSyncToggleEnabled">
      <ziro-radio [fieldId]="'cucmPhoneNumberAssignmentMatchType'"></ziro-radio>
      <div [hidden]="!lastDigitsMatchEnabled">
        <div class="alert alert-warning d-flex justify-content-between">
          <span>
            <i class="{{ ziroIcons.WARNING_TRIANGLE }} me-1"></i>
            <strong
              data-automation="proxy-feature-settings-end-match-warning"
              [innerHTML]="
                'tkey;admin.proxy_server_management.proxy_feature_settings.number_assignment_check.end_match_warning_banner.text'
                  | escapeHtml
              "
            ></strong>
          </span>
        </div>
        <ziro-text [fieldId]="'cucmPhoneNumberAssignmentLastDigitsMatch'"></ziro-text>
      </div>
    </div>
  </div>
</div>
